/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaarnumber_Een3Inputs */

const nl_enums_leerjaarnumber_een3 = /** @type {(inputs: Enums_Leerjaarnumber_Een3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1`)
};

/**

* @param {Enums_Leerjaarnumber_Een3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaarnumber_een3 = /** @type {((inputs?: Enums_Leerjaarnumber_Een3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaarnumber_Een3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaarnumber_een3(inputs)
});
export { enums_leerjaarnumber_een3 as "enums.LeerjaarNumber.Een" }